import { DestroyRef, inject } from '@angular/core';

export function useInterval(fn: () => void, interval: number) {
  const id = setInterval(fn, interval);
    
  inject(DestroyRef).onDestroy(() => clearInterval(id));
}